export default __webpack_public_path__ + "static/media/naviright.ebfff5f3.svg";